import { generateResultWithZod } from "@/lib/utils";
import { SubscriptionSchemas } from "./subscription.schemas";

const subscriptionFromApi = (subscription: unknown) => {
  return generateResultWithZod(
    SubscriptionSchemas.Subscription.Base,
    subscription,
    "Received invalid 'subscription' data from API"
  );
};

const subscriptionArrayListFromApi = (subscriptionArray: unknown) => {
  return generateResultWithZod(
    SubscriptionSchemas.Subscription.List,
    subscriptionArray,
    "Received invalid 'subscription' array data from API"
  );
};

const checkoutSessionFromApi = (checkoutSession: unknown) => {
  return generateResultWithZod(
    SubscriptionSchemas.CheckoutSession.Base,
    checkoutSession,
    "Received invalid 'checkout session' data from API"
  );
};

const billingPortalSessionFromApi = (session: unknown) => {
  return generateResultWithZod(
    SubscriptionSchemas.BillingPortalSession.Base,
    session,
    "Received invalid 'billing portal session' data from API"
  );
};

const invoiceFromApi = (invoice: unknown) => {
  return generateResultWithZod(
    SubscriptionSchemas.Invoice.Base,
    invoice,
    "Received invalid 'invoice' data from API"
  );
};

export const SubscriptionValidator = {
  Subscription: {
    fromAPI: subscriptionFromApi,
    Array: {
      fromAPI: subscriptionArrayListFromApi,
    },
  },
  CheckoutSession: {
    fromAPI: checkoutSessionFromApi,
  },
  BillingPortalSession: {
    fromAPI: billingPortalSessionFromApi,
  },
  Invoice: {
    fromAPI: invoiceFromApi,
  },
};
